import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  weatherResult: {},
  layersVisibility: {
    wind: {
      barb: false,
      particles: false,
    },
    temperature: false,
    waves: false,
    pressure: false,
  },
};

export const weatherReducer = createSlice({
  name: 'weatherSlice',
  initialState,
  reducers: {
    setWindVisibility: (
      state,
      action: PayloadAction<{
        barb: boolean;
        particles: boolean;
      }>,
    ) => {
      state.layersVisibility.wind = action.payload;
    },
    setTempVisibility: (state, action: PayloadAction<boolean>) => {
      state.layersVisibility.temperature = action.payload;
    },
    setWavesVisibility: (state, action: PayloadAction<boolean>) => {
      state.layersVisibility.waves = action.payload;
    },
    setPressureVisibility: (state, action: PayloadAction<boolean>) => {
      state.layersVisibility.pressure = action.payload;
    },
    hideWeather: (state) => {
      state.layersVisibility = {
        wind: {
          barb: false,
          particles: false,
        },
        temperature: false,
        waves: false,
        pressure: false,
      };
    },
  },
});

export const { setTempVisibility, setWindVisibility, setWavesVisibility, setPressureVisibility, hideWeather } =
  weatherReducer.actions;
export default weatherReducer.reducer;
